import { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { withTranslation } from 'react-i18next';

import { MdNotificationsNone } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
import Notificaciones from '../../pages/doctor/perfil/Notificaciones';
import FormPerfilDoctor from './FormPerfilDoctor';

function PerfilTabs({t, doctorInfo, notificaciones=[], auth,setDoctorInfo}){
    const [page, setPage] = useState(0)

    const handleChangePage = page => setPage(page)

    return (<>
       <Row className="page-container">
           <Col xs="6" sm="6" md="6" lg="6" xl="6" className={`${page===0 ? 'page-active' : 'page-inactive'} clicked`} onClick={()=>handleChangePage(0)}>
                <div className='tap-container'><FaRegUser /> {t('acerca_de_mi')}</div>
            </Col>
           <Col xs="6" sm="6" md="6" lg="6" xl="6" className={`${page===1 ? 'page-active' : 'page-inactive'} clicked`} onClick={()=>handleChangePage(1)}>
                <div className='tap-container'><MdNotificationsNone/> {t('notificaciones')}</div>
            </Col>
       </Row>

       <div className="body">
            { (page === 0) ? 
            <>{doctorInfo && <FormPerfilDoctor doctorInfo={doctorInfo} auth={auth} setDoctorInfo={setDoctorInfo}/>}</> :
            <Notificaciones doctorInfo={doctorInfo} notificaciones={notificaciones} /> }
       </div>

    </>);
}

export default withTranslation()(PerfilTabs)